// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import { DeploymentsResponse, StandardThunkAction } from 'types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';

// Action types
export const DEPLOYMENTS_REQUEST = Symbol('loaders/DEPLOYMENTS_REQUEST');
export const DEPLOYMENTS_SUCCESS = Symbol('loaders/DEPLOYMENTS_SUCCESS');
export const DEPLOYMENTS_ERROR = Symbol('loaders/DEPLOYMENTS_ERROR');

export type DeploymentsRequestAction = Action<typeof DEPLOYMENTS_REQUEST, null>;
export type DeploymentsSuccessAction = Action<
  typeof DEPLOYMENTS_SUCCESS,
  DeploymentsResponse
>;
export type DeploymentsErrorAction = Action<typeof DEPLOYMENTS_ERROR, Error>;

// Action creators
const deploymentsRequest = actionCreator<DeploymentsRequestAction>(
  DEPLOYMENTS_REQUEST,
);
const deploymentsSuccess = actionCreator<DeploymentsSuccessAction>(
  DEPLOYMENTS_SUCCESS,
);
const deploymentsError = actionCreator<DeploymentsErrorAction>(
  DEPLOYMENTS_ERROR,
);

export const loadDeployments = (): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(deploymentsRequest());

      const deployments = await API.client.deployments();

      dispatch(deploymentsSuccess(deployments));
    } catch (err) {
      dispatch(deploymentsError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-deployments.ts